import Vue from 'vue'
import VueRouter from 'vue-router';
import VTooltip from 'v-tooltip';
import VueCollapse from 'vue2-collapse';
//import App from '../app.vue';
import axios from 'axios';

import _orderBy from 'lodash/orderBy';
import _filter from 'lodash/filter';

import "core-js/stable";
import "regenerator-runtime/runtime";

Vue.use(VueRouter);
Vue.use(VTooltip);
Vue.use(VueCollapse);

import ProductGroup from '../product_selector/product_group.js';
import Product from '../product_selector/product.js';
import Question from '../product_selector/question.js';

import ProductCard from '../product_selector/product_card.vue';
import ProductGroupCard from '../product_selector/product_group_card.vue';

import Checkboxes from '../product_selector/questions/checkboxes.vue';
import Dropdown from '../product_selector/questions/dropdown.vue';
import Search from '../product_selector/questions/search.vue';
import Slider from '../product_selector/questions/slider.vue';


document.addEventListener('DOMContentLoaded', () => {
  const showDisabledQuestions = true;

  const configElement = document.getElementById('psAppConfig');
  if (configElement === null) { throw 'Config not found'; }
  const config = JSON.parse(configElement.innerHTML);
  if (config === undefined) { throw 'Config not OK'; }
  const feedUrl = config.feedUrl;
  if (feedUrl === undefined) { throw 'Data feed URL not found'; }

  const router = new VueRouter({
    mode: 'history',
    routes: [],
  });

  var app = new Vue({
    el: '#psApp',
    router,
    components: {
      Checkboxes,
      Dropdown,
      Slider,
      Search,
      ProductCard,
      ProductGroupCard,
      VTooltip,
      VueCollapse
    },
    data: {
      loading: true,
      loadOk: false,
      allProductGroups: [],
      allProducts: [],
      allQuestions: [],
      questionsToAsk: [],
      questionsAnswered: [],
      filteredProducts: [],
      filteredProductGroups: [],
      showDebugInfo: false,
      messages: []
    },
    beforeMount() {
      let apiData;
      this.fetchDataFromApi()
          .then(responses => {
            apiData = responses;
          })
          .catch(error => {
            console.log(`error: ${error}`);
          })
          .then(() => {
            if (apiData) {
              let data = apiData[0];
              let productGroupsData = data['product_groups'];
              let questionsData = data['questions'];

              let productGroups = ProductGroup.all(productGroupsData);
              this.allProductGroups = _orderBy(productGroups, ['position'], ['asc']); // ordering is unnecessary - API feed is ordered
              this.allProducts = Product.all(productGroupsData);

              let questions = Question.all(questionsData);
              this.allQuestions = _orderBy(questions, ['position'], ['asc']); // ordering is unnecessary - API feed is ordered

              this.loadOk = true;

              this.pullQuestionsAnsweredFromUrl();

              this.filterProducts();
              this.filterQuestionsToAsk();
              this.filterAnswersOfQuestionsToAsk();
              this.initialiseRangesOfSliders();
              this.autoSetSelectedAnswersOfSliders(this.questionsAnswered);
              this.updateDebugMessages();
            };
            this.loading = false;
            this.debugLog(`beforeMount successfully completed`);
          });
    },
    methods: {
      debugLog: function(...args) {
        // console.log(args);
      },
      selectedAnswersChanged: function(questionId, selectedAnswer) {
        this.debugLog('------------------------------------------------------');
        this.debugLog('Notification received that the selected answers have been changed...', questionId, selectedAnswer);
        let question = this.findQuestionById(questionId);
        this.setQuestionAsAnswered(question, selectedAnswer);

        this.filterProducts();
        this.filterQuestionsToAsk();
        this.filterAnswersOfQuestionsToAsk();
        this.autoSetSelectedAnswersOfSliders([question]);
        this.pushQuestionsAnsweredToUrl();
        this.updateDebugMessages();
      },
      reset: function() {
        this.debugLog('Reset please');
        this.resetQuestionsAnswered();
        this.clearUrl();

        this.filterProducts();
        this.filterQuestionsToAsk();
        this.filterAnswersOfQuestionsToAsk();
        this.autoSetSelectedAnswersOfSliders();
        this.updateDebugMessages();
      },
      filterProducts: function() {
        this.debugLog('Filter products');
        this.filteredProducts = Product.filter(this.allProducts, this.questionsAnswered);
        this.filteredProductGroups = ProductGroup.group(this.allProductGroups, this.filteredProducts);
      },
      filterQuestionsToAsk: function() {
        this.debugLog('Filter questions to ask');
        this.questionsToAsk = Question.questionsFilteredForProducts(this.allQuestions, this.filteredProducts);
        if (showDisabledQuestions) {
          this.questionsToAsk = this.allQuestions;
        }
      },
      filterAnswersOfQuestionsToAsk: function() {
        this.debugLog('Filter answers of questions to ask');
        for (let question of this.questionsToAsk) {
          // filter the question against a pool of products where this question has not been answered
          let questionsAnsweredExceptSelf = _filter(this.questionsAnswered, function(o) { return o.id !== question.id; })
          let lessFilteredProducts = Product.filter(this.allProducts, questionsAnsweredExceptSelf);
          question.disableFruitlessAnswers(lessFilteredProducts);
        }
      },
      initialiseRangesOfSliders: function() {
        if (this.allQuestions.length === 0) {
          console.warn('No questions to ask!  Am you calling me too early?');
        }
        this.debugLog('Set initial range of sliders');
        for (let question of this.allQuestions) {
          if (question.type !== 'slider') { continue; }
          question.setRange(this.allProducts);
        }
      },
      autoSetSelectedAnswersOfSliders: function(exceptQuestions) {
        this.debugLog('Auto-set selected answers of sliders');
        for (let question of this.allQuestions) {
          if (question.type !== 'slider') { continue; }
          this.debugLog(exceptQuestions);
          if (exceptQuestions && exceptQuestions.includes(question)) {
            continue;  // so we can skip updating the answers of the question they've just answered, or skip answers just loaded from the URL which shouldnt be instantly overridden
          }

          question.autoSetSelectedAnswers();
          // we've now set the selectedAnswers using the slider's own method - and we don't need to call setQuestionAsAnswered
          // - as that would explicitly make this seem as if it's just been answered - and you would no longer be able to keep
          // adding answers to the question you may have been answering.
        }
      },
      setQuestionAsAnswered: function(question, selectedAnswer) {
        this.debugLog(`Setting ${question.phrase} as answered...........`, selectedAnswer);

        // set the selectedAnswer on the question itself
        question.setAnswer(selectedAnswer);

        // Add/update this question to questionsAnswered
        // We add in (and preserve) the order they were answered in, so we can identify which question was last answered
        let newQuestionsAnswered = [];
        for (let q of this.questionsAnswered) {
          if (q.id !== question.id) { // add all but the question in question
            newQuestionsAnswered.push(q);
          }
        }
        if (selectedAnswer.toString(16).length > 0) { // clunky way of checking if integer or an array with items in, for now
          newQuestionsAnswered.push(question);
        }

        this.questionsAnswered = newQuestionsAnswered;
      },
      resetQuestionsAnswered: function() {
        // reset the selectedAnswer on each question
        for (var question of this.questionsAnswered) {
          question.reset();
        }
        // reset the overall list of answers (used for URL)
        this.questionsAnswered = [];
      },
      pushQuestionsAnsweredToUrl: function() {
        // go through our questionsAnswered and push them concisely to the URL
        let newState = Question.withAnswersForUrl(this.questionsAnswered);

        this.$router.push({
          query: {
            state: newState
          }
        });
      },
      clearUrl: function() {
        this.$router.push({
          query: {}
        });
      },
      pullQuestionsAnsweredFromUrl: function() {
        // go through our querystring and convert the values into questionsAnswered
        let state = eval('('+this.$route.query.state+')');

        if (state !== undefined) {
          this.debugLog(state);
          for (let q of state["questionsAnswered"]) {
            // this.debugLog(q);
            this.setQuestionAsAnswered(this.findQuestionById(q.questionId), q.selectedAnswer);
          }
        }
      },
      findQuestionById: function(id) {
        // try and load the question
        let question = this.allQuestions.find(x => x.id == id);
        if (question === undefined) {
          console.warn(`Question ${q.questionId} not found, this shouldn't happen.`);
        }
        return question;
      },
      updateDebugMessages: function() {
        this.messages = [];
        for (let question of this.questionsAnswered) {
          // console.log(question.constructor.name, question.type);
          this.messages.push(question.sayMessage());
        }
      },
      fetchDataFromApi: function() {
        return axios.all([
                      axios.get(feedUrl)
                    ])
                    .then(axios.spread((response) => {
                      return [response.data];
                    }))
                    .catch((err) => {
                      console.warn('FAIL', err)
                    });
      },
    },
  })
})
